import { storageOps, persistedLocalStorageKeys } from './storage';

const storageKeys = {
  SHOWED_DUDA_MIG_MODAL: 'showedDudaMigModal',
  PAGE_SECTION: 'pageSection',
  VISIT_UUID: 'visitUUID',
  VISIT_PROCESSED: 'visitProcessed',
  AVO_USER_UUID_STORE: 'avo_user_uuid_store'
};

export const pageSectionStore = storageOps({ key: storageKeys.PAGE_SECTION });

// Shared amongst all apps
export const visitUuidStore = storageOps({ key: storageKeys.VISIT_UUID });
export const visitProcessedStore = storageOps({ key: storageKeys.VISIT_PROCESSED });

// // Currently not used anywhere, but need to persist. Not sure why...
// eslint-disable-next-line max-len
export const zenBusinessPartnerStore = storageOps({ key: persistedLocalStorageKeys.ZENBUSINESS_PARTNER });
// eslint-disable-next-line max-len
export const zenBusinessPartnerTimerStore = storageOps({ key: persistedLocalStorageKeys.ZENBUSINESS_PARTNER_TIMER });
// eslint-disable-next-line max-len
export const zenBusinessEntryPointGroupStore = storageOps({ key: persistedLocalStorageKeys.ZENBUSINESS_ENTRY_POINT_GROUP });

export const ucAll = storageOps({ key: persistedLocalStorageKeys.UC_ACCEPTED_ALL });
export const ucFunctional = storageOps(persistedLocalStorageKeys.UC_ACCEPTED_ALL_FUNCTIONAL);
export const ucMarketing = storageOps({ key: persistedLocalStorageKeys.UC_ACCEPTED_ALL_MARKETING });

export const avoUserUuidStore = storageOps({
  key: storageKeys.AVO_USER_UUID_STORE
});
